import { ref } from 'vue'

const isOpen = ref(false)
const hasInteracted = ref(false)

export function useNavMenu() {
  const toggle = () => { hasInteracted.value = true; isOpen.value = !isOpen.value }
  const close = () => { hasInteracted.value = true; isOpen.value = false }
  const reset = () => { isOpen.value = false; hasInteracted.value = false }

  return { isOpen, hasInteracted, toggle, close, reset }
}
